export function getTimePickerValue(timePickerId) {
  if (!timePickerId) {
    throw Error("TimePicker ID Is Required");
  } else {
    // CREATE DEFAULT
    const timePickerValue = {
      hour: 10,
      minute: "00",
      period: "AM",
      timeString: "10:00"
    };

    let hour = +document.querySelector(`[name=${timePickerId}_hour]`).value;
    const minute = document.querySelector(
      `[name=${timePickerId}_minute]`
    ).value;
    const period = document.querySelector(
      `[name=${timePickerId}_period]`
    ).value;

    // RETURN 24 HR FORMAT

    // ADJUST HOUR IF IT'S PM
    if (period === "PM" && hour !== 12) {
      hour += 12;
    }

    // ADJUST HOUR IF IT'S MIDNIGHT (12 AM)
    if (period === "AM" && hour === 12) {
      hour = 0;
    }

    timePickerValue.hour = hour ?? timePickerValue.hour;
    timePickerValue.minute = minute ?? timePickerValue.minute;
    timePickerValue.period = period ?? timePickerValue.period;
    timePickerValue.timeString = `${
      timePickerValue.hour < 10
        ? "0" + timePickerValue.hour
        : timePickerValue.hour
    }:${timePickerValue.minute}`;
    // console.log(timePickerValue);

    return timePickerValue;
  }
}
